import {
  JOB_ALL_FAIL,
  JOB_ALL_REQUEST,
  JOB_ALL_SUCCESS,
  JOB_BY_ID_FAIL,
  JOB_BY_ID_REQUEST,
  JOB_BY_ID_RESET,
  JOB_BY_ID_SUCCESS,
  JOB_DELETE_FAIL,
  JOB_DELETE_REQUEST,
  JOB_DELETE_RESET,
  JOB_DELETE_SUCCESS,
  JOB_NEW_FAIL,
  JOB_NEW_REQUEST,
  JOB_NEW_RESET,
  JOB_NEW_SUCCESS,
  JOB_UPDATE_BY_ID_FAIL,
  JOB_UPDATE_BY_ID_REQUEST,
  JOB_UPDATE_BY_ID_RESET,
  JOB_UPDATE_BY_ID_SUCCESS,
} from '../constants/careerConstants';

export const jobNewReducer = (state = {}, action) => {
  switch (action.type) {
    case JOB_NEW_REQUEST:
      return { loading: true };
    case JOB_NEW_SUCCESS:
      return { loading: false, success: action.payload };
    case JOB_NEW_FAIL:
      return { loading: false, error: action.payload };
    case JOB_NEW_RESET:
      return {};
    default:
      return state;
  }
};

export const jobAllReducer = (state = { jobs: [] }, action) => {
  switch (action.type) {
    case JOB_ALL_REQUEST:
      return { loading: true };
    case JOB_ALL_SUCCESS:
      return {
        loading: false,
        totalItems: action.payload.totalItems,
        jobs: action.payload.items,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
      };
    case JOB_ALL_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const jobByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case JOB_BY_ID_REQUEST:
      return { ...state, loading: true };
    case JOB_BY_ID_SUCCESS:
      return { loading: false, success: true, job: action.payload };
    case JOB_BY_ID_FAIL:
      return { loading: false, error: action.payload };
    case JOB_BY_ID_RESET:
      return {};
    default:
      return state;
  }
};

export const jobUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case JOB_UPDATE_BY_ID_REQUEST:
      return { loading: true };
    case JOB_UPDATE_BY_ID_SUCCESS:
      return { loading: false, success: action.payload };
    case JOB_UPDATE_BY_ID_FAIL:
      return { loading: false, error: action.payload };
    case JOB_UPDATE_BY_ID_RESET:
      return {};
    default:
      return state;
  }
};

export const jobDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case JOB_DELETE_REQUEST:
      return { loading: true };
    case JOB_DELETE_SUCCESS:
      return { loading: false, success: action.payload };
    case JOB_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case JOB_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
